<template>
  <div>
    <button
      v-if="showButton"
      class="btn btn-info btn-sm"
      title="Vista previa de campos"
      :data-bs-toggle="'modal'"
      :data-bs-target="'#' + modalId"
    >
      <i class="fa fa-eye"></i>
    </button>
    <div class="modal fade" :id="modalId" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fs-5">VISTA PREVIA DE CAMPOS ADICIONALES</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <template v-if="fields && fields.length">
              <DinamicPreview :fields="fields" />
            </template>
            <template v-else>
              <div class="h3 text-center">
                Este formulario no tiene campos adicionales
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import DinamicPreview from './DinamicPreview.vue';

const props = defineProps({
  fields: {
    type: Array,
    default: () => [],
  },
  showButton: {
    type: Boolean,
    default: true,
  },
  modalId: {
    type: String,
    default: 'modal-dinamic-preview',
  },
});
</script>
